module.exports = __webpack_public_path__ + "790dd9f6ad12a42a9d314f006d13bf65.svg";